// Module
var code = "<customer-directory></customer-directory>\n";
// Exports
module.exports = code;